import { render, staticRenderFns } from "./StatusPeriodScore.vue?vue&type=template&id=4b785690"
import script from "./StatusPeriodScore.vue?vue&type=script&lang=js"
export * from "./StatusPeriodScore.vue?vue&type=script&lang=js"
import style0 from "./StatusPeriodScore.vue?vue&type=style&index=0&id=4b785690&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports